// /*
// GPS DataViz

// Copyright © 2021 GPSDataViz

// Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

// The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// */

import React from "react";
import { NavLink } from "react-router-dom";
import { Link } from "react-router-dom";
import { Layout, Menu, Button } from "antd";
import "../../Styles/styles-Header.css";
import Logo from "../../Images/newlogo1-01.png";
import {
  AppstoreOutlined,
  MailOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { useAuth0 } from "@auth0/auth0-react";
import { logoutRedirectUrl } from  "../../auth/auth0"
import * as Sentry from "@sentry/react";

// const { Header } = Layout;

// export const OnBoardingNav = () => {
//   const [logged_in, setLoggedIn] = React.useState(false);
//   const [current, setCurrent] = React.useState("");

//   const authAPI = new Auth();

//   React.useEffect(() => {
//     authAPI
//       .logged_in()
//       .then((data) => {
//         setLoggedIn(true);
//       })
//       .catch((data) => setLoggedIn(false));
//   }, []);

//   const logout = () => {
//     localStorage.removeItem("token");
//     localStorage.removeItem("email");

//     setLoggedIn(false);
//   };

//   const scrollToTarget = (ref) => {
//     console.log(ref);
//     if (ref === "/") {
//       return window.scrollTo({ top: 0, behavior: "smooth" });
//     }
//     const section = document.getElementById(ref);

//     section?.scrollIntoView({ behavior: "smooth", block: "start" });
//   };

//   return (
//     <>
//       <div className="outer-navbar">
//         <div className="navbar-navbar">
//           <Layout className="layout">
//             <Header style={{ backgroundColor: "white", padding: "0px" }}>
//               <Menu theme="light" mode="horizontal" selectedKeys={[current]}>
//                 <Menu.Item
//                   key="home"
//                   onClick={() => {
//                     setCurrent("/");
//                     scrollToTarget("/");
//                   }}
//                 >
//                   <NavLink to="/">
//                     <img className="navbar-logo" src={Logo} alt="navbar-logo" />
//                   </NavLink>
//                 </Menu.Item>
//                 {/* <Menu.Item key={2}><NavLink activeClassName="active-navbar-text" to="/features">Features</NavLink></Menu.Item> */}
//                 <div className="menu-btns">
//                   <Menu.Item key="#about">
//                     <NavLink
//                       activeClassName={
//                         current === "#about"
//                           ? "active-navbar-text"
//                           : "navbar-text"
//                       }
//                       to="/#about"
//                       onClick={() => {
//                         setCurrent("#about");
//                         setTimeout(() => scrollToTarget("#about"), 100);
//                       }}
//                     >
//                       ABOUT
//                     </NavLink>
//                   </Menu.Item>
//                   <Menu.Item key="#partners">
//                     <NavLink
//                       activeClassName={
//                         current === "#partners"
//                           ? "active-navbar-text"
//                           : "navbar-text"
//                       }
//                       to="/#partners"
//                       onClick={() => {
//                         setCurrent("#partners");
//                         setTimeout(() => scrollToTarget("#partners"), 100);
//                       }}
//                     >
//                       PARTNERS
//                     </NavLink>
//                   </Menu.Item>
//                   <Menu.Item key="#customer-success">
//                     <NavLink
//                       activeClassName={
//                         current === "#customer-success"
//                           ? "active-navbar-text"
//                           : "navbar-text"
//                       }
//                       to="/#customer-success"
//                       onClick={() => {
//                         setCurrent("#customer-success");
//                         setTimeout(
//                           () => scrollToTarget("#customer-success"),
//                           100
//                         );
//                       }}
//                     >
//                       CUSTOMER SUCCESS
//                     </NavLink>
//                   </Menu.Item>
//                   <Menu.Item key="#team">
//                     <NavLink
//                       activeClassName={
//                         current === "#team"
//                           ? "active-navbar-text"
//                           : "navbar-text"
//                       }
//                       to="/#team"
//                       onClick={() => {
//                         setCurrent("#team");
//                         setTimeout(() => scrollToTarget("#team"), 100);
//                       }}
//                     >
//                       THE TEAM
//                     </NavLink>
//                   </Menu.Item>
//                   {!logged_in && (
//                     <Menu.Item key={6}>
//                       <Link to="/login">
//                         <Button className="button-login">LOGIN</Button>
//                       </Link>
//                     </Menu.Item>
//                   )}
//                   {logged_in === true && (
//                     <Menu.Item key={7}>
//                       <Button onClick={logout} className="button-login">
//                         LOGOUT
//                       </Button>
//                     </Menu.Item>
//                   )}
//                 </div>
//               </Menu>
//             </Header>
//           </Layout>
//         </div>
//       </div>
//     </>
//   );
// };

export const OnBoardingNav = () => {
  const [current, setCurrent] = React.useState("");
  const dispatch = useDispatch();
  const { isAuthenticated, logout} = useAuth0();
  const {navigate} = useNavigate()

  const handleLogout = () => {
    // dispatch(logout());
  };

  const scrollToTarget = (ref) => {
    console.log(ref);
    if (ref === "/") {
      return window.scrollTo({ top: 0, behavior: "smooth" });
    }
    const section = document.getElementById(ref);

    section?.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  const onClick = (e) => {
    setCurrent(e.key);
  };
  return (
    <Menu onClick={onClick} selectedKeys={[current]} mode="horizontal" style={{height: '4.6em', display: 'flex', justifyContent: 'space-between'}}>
      <Menu.Item
        key="home"
        onClick={() => {
          setCurrent("/");
          scrollToTarget("/");
        }}
        style={{marginRight: 'auto'}}
      >
        <NavLink to="https://www.gpsdataviz.com/">
          <img className="navbar-logo" src={Logo} alt="navbar-logo" style={{marginTop: '0.6em'}} />
        </NavLink>
      </Menu.Item>

      {/* <Menu.Item
        key="#about"
        style={{
          marginLeft: "auto",
        }}
      >
        <NavLink
          activeClassName={
            current === "#about" ? "active-navbar-text" : "navbar-text"
          }
          to="/#about"
          onClick={() => {
            setCurrent("#about");
            setTimeout(() => scrollToTarget("#about"), 100);
          }}
        >
          ABOUT
        </NavLink>
      </Menu.Item>
        */}

      {/* <Menu.Item key="#partners">
        <NavLink
          activeClassName={
            current === "#partners" ? "active-navbar-text" : "navbar-text"
          }
          to="/#partners"
          onClick={() => {
            setCurrent("#partners");
            setTimeout(() => scrollToTarget("#partners"), 100);
          }}
        >
          PARTNERS
        </NavLink>
      </Menu.Item>

      <Menu.Item key="#testimonials">
        <NavLink
          activeClassName={
            current === "#testimonials" ? "active-navbar-text" : "navbar-text"
          }
          to="/#testimonials"
          onClick={() => {
            setCurrent("#testimonials");
            setTimeout(() => scrollToTarget("#testimonials"), 100);
          }}
        >
          TESTIMONIALS
        </NavLink>
      </Menu.Item>

      <Menu.Item key="#videos">
        <NavLink
          activeClassName={
            current === "#videos" ? "active-navbar-text" : "navbar-text"
          }
          to="/#videos"
          onClick={() => {
            setCurrent("#videos");
            setTimeout(() => scrollToTarget("#videos"), 100);
          }}
        >
          VIDEOS
        </NavLink>
      </Menu.Item>
      <Menu.Item key="#blogs">
        <NavLink
          activeClassName={
            current === "#blogs" ? "active-navbar-text" : "navbar-text"
          }
          to="/#blogs"
          onClick={() => {
            setCurrent("#blogs");
            setTimeout(() => scrollToTarget("#blogs"), 100);
          }}
        >
          BLOG
        </NavLink>
      </Menu.Item>
      <Menu.Item key="#customer-success">
        <NavLink
          activeClassName={
            current === "#customer-success"
              ? "active-navbar-text"
              : "navbar-text"
          }
          to="/#customer-success"
          onClick={() => {
            setCurrent("#customer-success");
            setTimeout(() => scrollToTarget("#customer-success"), 100);
          }}
        >
          CUSTOMER SUCCESS
        </NavLink>
      </Menu.Item>

      <Menu.Item key="#team">
        <NavLink
          activeClassName={
            current === "#team" ? "active-navbar-text" : "navbar-text"
          }
          to="/#team"
          onClick={() => {
            setCurrent("#team");
            setTimeout(() => scrollToTarget("#team"), 100);
          }}
        >
          THE TEAM
        </NavLink>
      </Menu.Item> */}

    <Menu.Item key={6}>
      <div style={{marginLeft: 'auto'}}>
        <Link to="/login">
          {!isAuthenticated ? 
          <Button className="button-login" onClick={()=>navigate("/")}>LOGIN</Button> : 
          <Button 
            onClick={async () => {
              Sentry.setUser(null);
              await logout({logoutParams: {returnTo: logoutRedirectUrl}});
            }}
            className="button-login"
          >
            LOGOUT
          </Button>
        }
        </Link>
      </div>
    </Menu.Item>
    </Menu>
  );
};
